module.exports = __webpack_public_path__ + "img/PDF.96163f11.png";